import React, { useMemo } from 'react';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import { Breadcrumb } from '../components';
import { useEnvironment } from '../contexts/EnvironmentContext';
import { useTimeRange } from '../contexts/TimeRangeContext';
import { useApp } from '../contexts/AppContext';
import SessionViewer from '../components/SessionViewer';

export default function SessionDetail() {
  const { selectedAppId, sessionId } = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { selectedEnvironment, environments } = useEnvironment();
  const { selectedRange } = useTimeRange();
  const { selectedAppName } = useApp();
  const initialSessionSummary = location.state?.sessionSummary || null;

  const appName = useMemo(() => {
    if (selectedAppName) return selectedAppName;
    if (selectedAppId && environments.length) {
      for (const env of environments) {
        const app = env.apps?.find(a => a.id === selectedAppId);
        if (app) return app.name;
      }
    }
    return selectedAppId;
  }, [selectedAppId, selectedAppName, environments]);

  const breadcrumbItems = useMemo(() => {
    const params = new URLSearchParams();
    if (selectedEnvironment) params.set('env', selectedEnvironment);
    if (selectedRange) params.set('range', selectedRange);
    const queryString = params.toString() ? `?${params.toString()}` : '';

    const telemetryParams = new URLSearchParams(params);
    telemetryParams.set('tab', 'telemetry');
    telemetryParams.set('subtab', 'sessions');
    const telemetryQs = `?${telemetryParams.toString()}`;

    return [
      { label: appName, to: `/app/${selectedAppId}${queryString}` },
      { label: 'Sessions', to: `/app/${selectedAppId}${telemetryQs}` },
      { label: sessionId },
    ];
  }, [appName, selectedAppId, selectedEnvironment, selectedRange, sessionId]);

  return (
    <div className="flex flex-col h-full gap-4">
      <Breadcrumb items={breadcrumbItems} />
      <SessionViewer
        appId={selectedAppId}
        sessionId={sessionId}
        initialSessionSummary={initialSessionSummary}
        variant="page"
        initialTraceId={searchParams.get('traceId') || null}
      />
    </div>
  );
}
